//@ts-ignore
import MSGReader from "./msgReader/msgReader";
import { api } from "../../../api/api";
import { getFileExtensionFromUrl } from "./getFileNameFromUrl";
import { createMSGPreviewTemplate } from "./createMSGPreviewTemplate";

export const previewFile = async (fileName: string | null) => {
  if (!fileName) return null;

  // Get file extension
  const extension = fileName.split(".").pop()?.toLowerCase();

  // Fetch the file
  const res = await api.post(
    "/general/download-files",
    {
      type: "",
      keys: [fileName],
    },
    {
      responseType: "arraybuffer",
    },
  );

  if (extension === "msg") {
    const arrayBuffer = res.data;
    const reader = MSGReader(arrayBuffer);
    const msg = reader.getFileData();

    const htmlContent = createMSGPreviewTemplate(msg);

    const newWindow = window.open();
    if (newWindow) {
      newWindow.document.open();
      newWindow.document.write(htmlContent);
      newWindow.document.close();
    } else {
      alert("Pop-up blocked. Please allow pop-ups for this site.");
    }
  } else {
    // Default preview logic
    const blob = new Blob([res.data], {
      type: "application/" + getFileExtensionFromUrl(fileName),
    });
    const url = window.URL.createObjectURL(blob);
    window.open(url, "_blank");
  }

  return null;
};
